import * as React from 'react'

import type { IconProps } from '@/icons/types'
export const TriangleDownMini = React.forwardRef<SVGSVGElement, IconProps>(
	({ color = 'currentColor', ...props }, ref) => {
		return (
			<svg xmlns='http://www.w3.org/2000/svg' width={15} height={15} fill='none' ref={ref} {...props}>
				<path
					fill={color}
					d='M10.09 5c.163 0 .323.037.463.108.14.07.256.172.335.293a.7.7 0 0 1 .111.397.7.7 0 0 1-.141.39l-2.59 3.454a.9.9 0 0 1-.33.263 1.04 1.04 0 0 1-.876 0 .9.9 0 0 1-.33-.263l-2.59-3.455A.7.7 0 0 1 4 5.797a.7.7 0 0 1 .112-.396.85.85 0 0 1 .335-.293c.14-.07.3-.108.463-.108z'
				/>
			</svg>
		)
	}
)
TriangleDownMini.displayName = 'TriangleDownMini'
